import * as Config from '../../../../config';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import useGetFromApi from '../../../../hooks/useGetFromApi';

const useCreateRoom = (cancelClick) => {
  const DEFAULT_GENRE = 'Open Format';
  const socket = useSelector( state => state.socketPM);

  const [response] = useGetFromApi(`genres`, `/catalog/genres/`);
  let genres = response ? response.items.map( x => x.name ) : [];
  genres.unshift(DEFAULT_GENRE);
  const labelButton = 'Start Set';
  const [isPrivate, setPrivate] = useState(false);
  const [name, setName] = useState('');
  const [genre, setGenre] = useState(DEFAULT_GENRE);
  const [limit, setLimit] = useState(4); // DEFAULT
  const [error, setError] = useState(false);

  const clickSwitch = () => {
    setPrivate( state => !state );
  }

  const selectLimit = (nb) => () => {
    setLimit(nb);
  }

  const cancelButton = () => {
    cancelClick();
  }

  const clickButton = () => {
    if (name.length > 0) {
      if (socket) {
        socket.emit("create room", {
          from: Config.ACRONYME,
          name,
          genre,
          limit,
          private: isPrivate
        });
      }
      setError(false);
      cancelClick();
    } else {
      setError(true);
    }
  }

  const customHook = {
    error,
    name, setName,
    genres, genre, setGenre,
    isPrivate,
    clickSwitch,
    selectLimit, limit,
    clickButton,
    cancelButton,
    labelButton
  };

  return customHook;
};

export default useCreateRoom;
